import React, { Fragment } from "react";
import { withStyles, withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import RouteMappingToolMAP from "./components/Map";
import styles from "./styles";
import RouteMappingSidePanel from "./components/RouteMappingSidePanel";
import MapDrawingToolBox from "../../common/DrawTools/DrawingToolsBox";
import {
  getDataWithQueryString,
  postData,
} from "../../../../../api/componentAPIs";
import DeleteRouteMapping from "./components/DeleteRouteMapping";
import AlertPopup from "./components/common/AlertPopup";
import Events from "../../../../../utilities/EventEmitter";
import constants from "./constants";
import drawConstant from "../../common/DrawTools/DrawConstant";
import { RMAXLogger } from "../../../../../services/LoggerService/RMAXLogger";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import appConstants from "../../../../../appConstants";
class RouteMappingTool extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: true,
      routeMappingData: [],
      doorData : [],
      filteredRouteMappingList: [],
      selectedRouteMapper: [],
      selectedRouteMappingList: [],
      isDeleteRouteMappingOpen: false,
      selectedIds: [],
      storedCreatedPolygonIds: [],
      drawingInProgress: false,
      selectedFilterOption: constants.ROUTE_MAPPING_FILTER_OPTIONS[2],
    };
    this.showDoorNumber = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableDoorForRouteMapping
    );
  }
  componentDidMount() {
    RMAXLogger.info("RouteMappingVisited");
    this.getRouteMappingData();
    this.showDoorNumber && this.getDoorData();
    Events.on(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_IN_PROGRESS,
      this.handleInProgressDrawing
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userData.userProfile.terminal.id !==
      this.props.userData.userProfile.terminal.id
    ) {
      this.getRouteMappingData();
      this.showDoorNumber && this.getDoorData();
    }
  }

  componentWillUnmount() {
    Events.off(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_IN_PROGRESS,
      this.handleInProgressDrawing
    );
  }

  getRouteMappingData = () => {
    getDataWithQueryString(
      "GetRouteMapping",
      `terminalId=${this.props.userData.userProfile.terminal.id}`
    ).then((response) => {
      if (response && response.status >= 200 && response.status < 400) {
        const formattedData = this.getFormattedData(response.data);
        const allSelectedIds = this.getAllSelectedIds(response.data);
        const selectedIds = allSelectedIds.length
          ? allSelectedIds
          : formattedData.map((item) => item.routeMappingId);
        this.setState({
          routeMappingData: formattedData,
          selectedRouteMappingList: this.getFilteredData(formattedData),
          selectedIds: selectedIds,
          storedCreatedPolygonIds: [],
        });
        this.routeMappingFilterChange(this.state.selectedFilterOption);
      }
    });
  };

  getDoorData = () => {
    getDataWithQueryString(
      "GetDoorData",
      `terminalId=${this.props.userData.userProfile.terminal.id}`
    ).then((response) => {
      if (response?.status >= 200 && response?.status < 400) {
        this.setState({
          doorData : response.data ?? []
        })
      }
    });
  };

  getAllSelectedIds = () => {
    const allSelectedIds = [...this.state.selectedIds];
    if (this.state.storedCreatedPolygonIds.length) {
      allSelectedIds.push(...this.state.storedCreatedPolygonIds);
    }
    return allSelectedIds;
  };

  handleInProgressDrawing = () => {
    this.setState({
      drawingInProgress: true,
    });
  };

  onClose = () => {
    this.setState({
      drawingInProgress: false,
    });
  };

  getFormattedData = (data) => {
    return data
      .map((routeMapping) => {
        return {
          ...routeMapping,
          boundary: JSON.parse(routeMapping.boundary),
        };
      })
      .sort((a, b) => (a.routeMappingId < b.routeMappingId ? 1 : -1));
  };

  getFilteredData = (data) => {
    return this.state.selectedIds.length
      ? data.filter((item) =>
          this.state.selectedIds.includes(item.routeMappingId)
        )
      : data;
  };

  deleteCards = (cards) => {
    this.setState({
      selectedRouteMapper: cards.map((card) => card.data),
      isDeleteRouteMappingOpen: true,
    });
  };

  deleteRouteMappingPopupClose = () => {
    Events.emit(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP,
      "cancel",
      true
    );
    this.setState({
      selectedRouteMapper: [],
      isDeleteRouteMappingOpen: false,
    });
  };

  deleteRouteMappingConfirm = () => {
    const request = {
      terminalId: this.props.userData.userProfile.terminal.id,
      terminalCode: this.props.userData.userProfile.terminal.code,
      routeMappingIds: this.state.selectedRouteMapper.map(
        (data) => data.routeMappingId
      ),
    };
    postData("DeleteRouteMapping", request).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.CLOSE_FORM, true);
          RMAXLogger.info("RouteMappingDeleted", {
            routeMappingIds: request.routeMappingIds,
          });
          this.setState({ selectedIds: [] });
          this.getRouteMappingData();
          this.props.enqueueSnackbar(
            "Route mapping area deleted successfully",
            {
              variant: "success",
            }
          );
          return;
        }
        this.handleError(response.status);
      },
      () => {
        this.handleError();
      }
    );
  };

  handleError = (statusCode) => {
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar("Error while deleting route mapping area ", {
      variant: "error",
    });
  };

  routeMappingFilterChange = (option) => {
    if (option) {
      const optionValue = option.value;
      const filteredData =
        optionValue !== constants.ROUTE_MAPPING_FILTER_OPTIONS[0].value
          ? this.state.routeMappingData.filter(
              (item) => item.type === optionValue
            )
          : this.state.routeMappingData;
      const selectedData =
        this.state.selectedIds.length &&
        optionValue === this.state.selectedFilterOption.value
          ? filteredData.filter((item) =>
              this.state.selectedIds.includes(item.routeMappingId)
            )
          : filteredData;
      this.setState({
        filteredRouteMappingList: filteredData,
        selectedRouteMappingList: selectedData,
        selectedIds: selectedData.map((item) => item.routeMappingId),
        selectedFilterOption: option,
      });
    }
  };

  toggleExpand = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
    this.props.glEventHub.emit("mapResize");
  };

  onSelectionChanged = (selectedIds) => {
    const selectedData = selectedIds.length
      ? this.state.routeMappingData.filter((item) =>
          selectedIds.includes(item.routeMappingId)
        )
      : [];
    this.setState({
      selectedIds: [...new Set(selectedIds)],
      selectedRouteMappingList: selectedData,
    });
  };

  storeCreatedFeature = (featureIds) => {
    this.setState({
      storedCreatedPolygonIds: featureIds,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <header
          className={classes.moduleHeader}
          data-automationid="RouteMappingTool-title"
        >
          Route Mapping Tool
          <span className={classes.headerIcons}>
            <MapDrawingToolBox lasso delete />
          </span>
        </header>
        <div className={classes.subModule}>
          <RouteMappingToolMAP
            eventHub={this.props.glEventHub}
            data={this.state.selectedRouteMappingList}
            defaultThemeColor= {this.props.theme.commonAppHeaderTabColor}
          />
          <RouteMappingSidePanel
            data={this.state.routeMappingData}
            filteredRouteMappingList={this.state.filteredRouteMappingList}
            isExpanded={this.state.isExpanded}
            toggleExpand={this.toggleExpand}
            deleteCards={this.deleteCards}
            isAddUpdateMode={this.state.isAddUpdateMode}
            getRouteMappingData={this.getRouteMappingData}
            onSelectionChanged={this.onSelectionChanged}
            selectedIds={this.state.selectedIds}
            storeCreatedFeature={this.storeCreatedFeature}
            routeMappingFilterChange={this.routeMappingFilterChange}
            selectedFilterOption={this.state.selectedFilterOption}
            userProfile={this.props.userData.userProfile}
            doorData = {this.state.doorData}
            showDoorNumber = {this.showDoorNumber}
          />
        </div>
        {this.state.drawingInProgress && (
          <AlertPopup
            title="Drawing in progress"
            message="Drawing in progress, please save or cancel to continue."
            onClose={this.onClose}
          />
        )}
        {this.state.isDeleteRouteMappingOpen && (
          <DeleteRouteMapping
            selectedRouteMapper={this.state.selectedRouteMapper}
            onCancel={this.deleteRouteMappingPopupClose}
            onConfirm={this.deleteRouteMappingConfirm}
          />
        )}
      </Fragment>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar,
  withFeatureFlags,
  withTheme()
)(RouteMappingTool);
